/**
 * O menu da mesa aberta, no botão direito do ícone dela na barra da esquerda
 * (docs/spec/room-menus.md). Quem monta a lista é a área de trabalho da mesa (`RoomDesktop`), que
 * conhece os painéis e as permissões; a barra só pede a lista na hora de abrir o menu.
 */
import type { MenuEntry } from '../ui/ContextMenu.js';

type Provider = { roomId: string; entries: () => MenuEntry[] | null };

let provider: Provider | null = null;

/** A mesa à vista oferece o menu dela; a função devolvida o retira. */
export function provideRoomMenu(roomId: string, entries: () => MenuEntry[] | null): () => void {
  const mine: Provider = { roomId, entries };
  provider = mine;
  return () => {
    if (provider === mine) provider = null;
  };
}

/** O menu da mesa, se ela é a que está montada; senão, null (fica só o "Sair da mesa"). */
export function roomMenuEntries(roomId: string): MenuEntry[] | null {
  return provider?.roomId === roomId ? provider.entries() : null;
}
